<div *ngIf="showSnackBar" class="snack-bar-container" (click)="closeSnackBar()">
  <ng-container *ngIf="snackBarSuccess; else snackBarErrorTemplate">
    <div class="snack-bar-success">
      <div class="snack-bar-content">
        <div class="status-icon"></div>
        <div class="data">{{ snackBarMessageInput }}</div>
        <div class="close-icon" (click)="closeSnackBar()"></div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #snackBarErrorTemplate>
  <div class="snack-bar-error">
    <div class="snack-bar-content">
      <div class="status-icon"></div>
      <div class="data">{{ 'PASSENGER_CHANGE.RESULT.ERROR' | translate }}</div>
      <div class="close-icon" (click)="closeSnackBar()"></div>
    </div>
  </div>
</ng-template>
